async function cartDiscountUpdate(cachedCart) {
  // ✅ localStorage에서 직접 가져오기 (DOM 의존성 제거)
  let customerId = localStorage.getItem('shopifyId');
  let customerEmail = localStorage.getItem('customerEmail');

  // localStorage에 없으면 DOM에서 가져오기 (fallback)
  if (!customerId || !customerEmail) {
    const customerIdElement = document.querySelector('[data-customer-id]');
    const customerEmailElement = document.querySelector('[data-customer-email]');

    if (customerIdElement) {
      customerId = customerIdElement.getAttribute('data-customer-id');
    }
    if (customerEmailElement) {
      customerEmail = customerEmailElement.getAttribute('data-customer-email');
    }
  }

  // 고객 정보가 없으면 종료
  if (!customerId || !customerEmail || customerId === 'not-found') {
    console.log('🔍 [쿠폰] 비로그인 상태 또는 고객 정보 없음 - 쿠폰 적용 건너뜀');
    return { cartData: null };
  }

  console.log('🔍 [쿠폰] customerId:', customerId, 'customerEmail:', customerEmail);

  localStorage.setItem('shopifyId', customerId);
  localStorage.setItem('customerEmail', customerEmail);

  // 카트 조회 + 멤버십 쿠폰 목록 동시 조회
  const useCouponCode = sessionStorage.getItem('useCouponCode');
  console.log('🔍 [디버깅] sessionStorage.useCouponCode:', useCouponCode);

  const cartPromise = cachedCart ? Promise.resolve(cachedCart) : window.CustomApi.getCart().then(r => r.json());
  // 수동 쿠폰이 없을 때만 멤버십 쿠폰 API 호출 (병렬)
  const couponPromise = useCouponCode
    ? Promise.resolve(null)
    : window.CustomApi.getMembershipCouponList(customerId, customerEmail)
        .then(r => r.json())
        .catch(error => {
          console.error('[coupon] getMembershipCouponList failed:', error);
          return null;
        });

  const [cartData, couponData] = await Promise.all([cartPromise, couponPromise]);

  if (!cartData) return { cartData: null };

  console.log('🔍 [디버깅] 현재 장바구니 쿠폰:', cartData.discount_codes);

  let couponCode = null;

  if (useCouponCode) {
    couponCode = useCouponCode;
    console.log('✅ [수동 사용 쿠폰]', useCouponCode);
  } else {
    console.log('🔍 [디버깅] 쿠폰 개수:', Array.isArray(couponData) ? couponData.length : 'Not an array');

    const recommendedCoupon = recommendBestCoupon(cartData, couponData, new Date(), { units: 'minor' });
    console.log('🔍 [디버깅] recommendBestCoupon 결과:', recommendedCoupon);

    couponCode = recommendedCoupon?.code;
    console.log('✅ [추천 쿠폰]', couponCode);
  }

  // 쿠폰 코드가 없으면 카트 데이터만 반환
  if (!couponCode) {
    console.log('[쿠폰 없음] 적용할 쿠폰이 없습니다.');
    return { cartData };
  }

  // 이미 적용된 쿠폰 체크
  if (cartData.discount_codes.find(item => item.code === couponCode)) {
    console.log('[이미 적용된 쿠폰]', couponCode);
    return { cartData };
  }

  // 3️⃣ 할인 적용 - Ajax Cart API 사용 (더 안정적)
  console.log('🔍 [디버깅] 쿠폰 적용 시도 (Ajax Cart API):', couponCode);

  let updatedCart;
  try {
    const updateResponse = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {},
        note: '',
        discount: couponCode
      })
    });

    if (!updateResponse.ok) {
      throw new Error(`HTTP error! status: ${updateResponse.status}`);
    }

    updatedCart = await updateResponse.json();

    const appliedDiscount = updatedCart.discount_codes?.find(d => d.code === couponCode);

    if (!appliedDiscount) {
      console.warn('[쿠폰 적용 실패] 장바구니에 쿠폰이 적용되지 않음:', couponCode);
      console.log('[쿠폰 유지] 다음번에 조건 충족 시 재시도');
      return { cartData, success: false };
    }

    console.log('[할인 자동 적용 성공]', couponCode, updatedCart.discount_codes);
  } catch (error) {
    console.error('❌ [쿠폰 적용 에러]', error);
    return { cartData, success: false };
  }

  // ✅ 성공 시 sessionStorage에서 제거 (중복 적용 방지)
  sessionStorage.removeItem('useCouponCode');

  // 쿠폰 적용 후 cart key 동기화 + 최신 카트 데이터 반환
  // ✅ /cart.js 1회만 호출하여 key 동기화 + 최신 데이터 반환
  const freshCart = await fetch('/cart.js').then(r => r.json());
  await refreshCartItemKeysFromCart(freshCart);

  return { cartData: freshCart, success: true };
}

async function cartFetchStorefrontApi(query, variables) {
  const response = await fetch(API_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
    },
    body: JSON.stringify({ query, variables }),
  });
  const result = await response.json();
  return result.data || {};
}

async function applyDiscountCodes(cartId, discountCodes) {
  const mutation = `
    mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
      cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
        cart {
          id
          discountCodes {
            code
            applicable
          }
        }
        userErrors {
          field
          message
          code
        }
      }
    }
  `;
  const variables = { cartId, discountCodes };
  return await cartFetchStorefrontApi(mutation, variables);
}

// 할인 적용 등으로 cart line key가 바뀐 경우, DOM의 key 관련 data-attributes를 최신화
// ✅ data-merge-list-item 기반 매칭 (data-index 대신)
// data-merge-list-item은 서버가 렌더링한 값이므로 DOM 재정렬(groupBundleItems)과 무관하게 정확
async function refreshCartItemKeysFromCart(cachedCart) {
  const cart = cachedCart || await fetch('/cart.js').then(r => r.json());
  if (!cart || !Array.isArray(cart.items)) return;

  const BUNDLE_DISCOUNT_TITLE = '함께 구매하기 좋은 상품';

  // variant_id별 cart items 그룹핑 (같은 variant가 여러 개인 경우 처리용)
  const cartItemsByVariant = {};
  cart.items.forEach(item => {
    const vid = item.variant_id.toString();
    if (!cartItemsByVariant[vid]) cartItemsByVariant[vid] = [];
    cartItemsByVariant[vid].push(item);
  });

  const usedCartKeys = new Set();

  // ✅ wrapper([data-cart-items-main]) 기반 매칭
  // data-merge-list-item에서 variant_id와 번들 여부를 추출하여 cart.js 아이템과 매칭
  const wrappers = document.querySelectorAll('[data-cart-items-main]');

  wrappers.forEach(wrapper => {
    const li = wrapper.querySelector('li.cart-item');
    if (!li) return;

    const mergeAttr = wrapper.getAttribute('data-merge-list-item') || '';
    const mergeKeyPart = mergeAttr.split('|')[0]; // "item-key:variant_id:hash"
    const mergeKey = mergeKeyPart.split('item-key:')[1]; // "variant_id:hash"
    if (!mergeKey) return;

    const variantId = mergeKey.split(':')[0];
    const isBundleWrapper = mergeAttr.includes(BUNDLE_DISCOUNT_TITLE);
    const candidates = cartItemsByVariant[variantId] || [];

    let cartItem;

    if (candidates.length === 1) {
      cartItem = candidates.find(item => !usedCartKeys.has(item.key));
    } else if (candidates.length > 1) {
      // 같은 variant가 여러 개: 번들 상태로 구분
      cartItem = candidates.find(item => {
        if (usedCartKeys.has(item.key)) return false;
        const isBundle = item.line_level_discount_allocations?.some(
          alloc => alloc.discount_application?.title === BUNDLE_DISCOUNT_TITLE
        );
        return isBundleWrapper ? isBundle : !isBundle;
      });
      // fallback: 번들 매칭 실패 시 미사용 아이템 사용
      if (!cartItem) {
        cartItem = candidates.find(item => !usedCartKeys.has(item.key));
      }
    }

    if (!cartItem) return;

    usedCartKeys.add(cartItem.key);

    // DOM 속성 갱신
    li.setAttribute('data-key', cartItem.key);
    wrapper.setAttribute('data-item-key', cartItem.key);

    // 체크박스 data-item-key, value, id, label for 동기화
    const checkbox = li.querySelector('input[data-cart-checkbox]');
    if (checkbox) {
      checkbox.setAttribute('data-item-key', cartItem.key);
      checkbox.value = cartItem.key;
      const newId = `item-${cartItem.key}`;
      checkbox.id = newId;

      const checkboxWrap = checkbox.closest('.aw-cart__checkboxWrap');
      if (checkboxWrap) {
        const label = checkboxWrap.querySelector('label');
        if (label) label.setAttribute('for', newId);
      }
    }
  });
}
